module.exports = __webpack_public_path__ + "assets/9b2b08fb353ff927f4eaf5a448be5761.png";